import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";

export const DEFAULT_COUNTRY_CODE = 'US';
export const DEFAULT_LANGUAGE = LocaleTypes.ENGLISH;
export const DEFAULT_NAMESPACE = 'dcui';
export const DEFAULT_ALLOWED_TAGS = [
	'img',
	'span',
	'p',
	'<br/>',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'div',
	'td',
	'tr',
	'thead',
	'tbody',
	'table'
];
export const ALL_ALLOWED_TAGS = [...DEFAULT_ALLOWED_TAGS, 'header', 'ul', 'li', 'nav', 'footer'];
export const WHITE_COLOR = '#ffffff';
export const SMALL_DEVICE = 'sd';
export const BREAKPOINTS = {
	xs: 'xs',
	[SMALL_DEVICE]: SMALL_DEVICE,
	sm: 'sm',
	md: 'md',
	lg: 'lg'
};
export const MAX_BLUR_FAILURES_BEFORE_NATIVE_CAMERA = 1;